// extracted by mini-css-extract-plugin
export default {"agency__about__item":"AboutAgencyListItem_agency__about__item__sm-OA","agency__about__item__link":"AboutAgencyListItem_agency__about__item__link__eYrwo"};